import { Image } from '@/components/ui/image';
import cn from 'classnames';
import Link from '@/components/ui/link';
import { logoPlaceholder, logoWhitePlaceholder } from '@/lib/placeholders';
import { useSettings } from '@/framework/settings';

const Logo: React.FC<
  React.AnchorHTMLAttributes<{}> & {
    useImg?: boolean;
    useWhite?: boolean;
    width?: number;
    height?: number;
  }
> = ({
  className,
  useImg = false,
  width = 250,
  height = 70,
  useWhite = false,
  ...props
}) => {
  const {
    settings: { logo, siteTitle },
  }: any = useSettings();

  const logoSrc =
    useImg && logo?.original
      ? logo.original
      : useWhite
        ? logoWhitePlaceholder
        : logoPlaceholder;

  return (
    <Link href="/" className={cn('inline-flex', className)} {...props}>
      <span className="relative overflow-hidden">
        <Image
          unoptimized={true}
          src={logoSrc}
          alt={siteTitle || 'Qualidoc Logo'}
          width={width}
          height={height}
          sizes="(max-width: 768px) 100vw"
          loading="eager"
          className="object-contain"
        />
      </span>
    </Link>
  );
};

export default Logo;
